import type { HcpLinkClickSchema } from 'lib/analytics/schema';
import { HCP } from 'lib/constants/navigation';

import { useAnalytics } from './useAnalytics';

export const useHcpLinkTracking = (
  name: string | undefined,
  context: HcpLinkClickSchema,
) => {
  const { analytics } = useAnalytics();

  if (name !== HCP.name) return undefined;

  return () => analytics.hcpLinkClick(context);
};
